import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Translations
const translations = {
  en: {
    // Header
    brand: "UnitedHands",
    brandLocation: "KARUR",
    tagline: "Connecting Karur Businesses & People",
    addYourShop: "Add Your Shop",
    login: "Login",
    logout: "Logout",
    dashboard: "Dashboard",
    admin: "Admin",
    
    // Hero
    location: "Karur, Tamil Nadu",
    heroTitle: "Find the best services near you",
    searchPlaceholder: "Search fish shop, laptop service, hospital...",
    search: "Search",
    
    // Categories
    categories: "Categories",
    viewAll: "View All",
    
    // Features
    discoverTitle: "Discover the Best Services in Karur!",
    callLocate: "Call & Locate Easily",
    callLocateDesc: "Quick access to phone and location",
    topRated: "Top Rated Listings",
    topRatedDesc: "Find trusted businesses",
    growBusiness: "Grow Your Business",
    growBusinessDesc: "List your shop and reach more customers",
    
    // Business
    call: "Call",
    whatsapp: "WhatsApp",
    getDirections: "Get Directions",
    reviews: "Reviews",
    writeReview: "Write a Review",
    noReviews: "No reviews yet. Be the first to review!",
    rating: "Rating",
    submit: "Submit",
    
    // Auth
    loginTitle: "Welcome Back",
    registerTitle: "Create Account",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    confirmPassword: "Confirm Password",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    registerNow: "Register Now",
    loginNow: "Login Now",
    
    // Add Shop
    addShopTitle: "Add Your Shop",
    shopName: "Shop Name",
    shopNameTa: "Shop Name (Tamil)",
    category: "Category",
    description: "Description",
    descriptionTa: "Description (Tamil)",
    address: "Address",
    addressTa: "Address (Tamil)",
    website: "Website",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadImages: "Upload Images",
    workingHours: "Working Hours",
    submitForApproval: "Submit for Approval",
    
    // Dashboard
    myShops: "My Shops",
    pending: "Pending Approval",
    approved: "Approved",
    rejected: "Rejected",
    edit: "Edit",
    delete: "Delete",
    
    // Admin
    adminPanel: "Admin Panel",
    pendingApprovals: "Pending Approvals",
    allBusinesses: "All Businesses",
    allUsers: "All Users",
    manageCategories: "Manage Categories",
    approve: "Approve",
    reject: "Reject",
    
    // Footer
    footerTagline: "Connecting local businesses with customers in Karur",
    quickLinks: "Quick Links",
    home: "Home",
    about: "About Us",
    contact: "Contact",
    privacy: "Privacy Policy",
    copyright: "© 2024 UnitedHands Karur. All rights reserved.",
    
    // Misc
    loading: "Loading...",
    error: "Something went wrong",
    noResults: "No results found",
    selectCategory: "Select a category",
    allCategories: "All Categories"
  },
  ta: {
    // Header
    brand: "யுனைடெட்ஹேண்ட்ஸ்",
    brandLocation: "கரூர்",
    tagline: "கரூர் வணிகங்களையும் மக்களையும் இணைக்கிறது",
    addYourShop: "உங்கள் கடையைச் சேர்க்கவும்",
    login: "உள்நுழைய",
    logout: "வெளியேறு",
    dashboard: "டாஷ்போர்டு",
    admin: "நிர்வாகி",
    
    // Hero
    location: "கரூர், தமிழ்நாடு",
    heroTitle: "உங்களுக்கு அருகிலுள்ள சிறந்த சேவைகளைக் கண்டறியுங்கள்",
    searchPlaceholder: "மீன் கடை, லேப்டாப் சேவை, மருத்துவமனை தேடுங்கள்...",
    search: "தேடு",
    
    // Categories
    categories: "வகைகள்",
    viewAll: "அனைத்தும் காண்க",
    
    // Features
    discoverTitle: "கரூரில் சிறந்த சேவைகளைக் கண்டறியுங்கள்!",
    callLocate: "எளிதாக அழைத்து கண்டறியுங்கள்",
    callLocateDesc: "தொலைபேசி மற்றும் இருப்பிடத்திற்கு விரைவான அணுகல்",
    topRated: "சிறந்த மதிப்பீட்டு பட்டியல்கள்",
    topRatedDesc: "நம்பகமான வணிகங்களைக் கண்டறியுங்கள்",
    growBusiness: "உங்கள் வணிகத்தை வளர்க்கவும்",
    growBusinessDesc: "உங்கள் கடையை பட்டியலிட்டு அதிக வாடிக்கையாளர்களை அடையுங்கள்",
    
    // Business
    call: "அழைப்பு",
    whatsapp: "வாட்ஸ்அப்",
    getDirections: "வழிகளைப் பெறுங்கள்",
    reviews: "விமர்சனங்கள்",
    writeReview: "விமர்சனம் எழுதுங்கள்",
    noReviews: "இதுவரை விமர்சனங்கள் இல்லை. முதலில் விமர்சிக்கவும்!",
    rating: "மதிப்பீடு",
    submit: "சமர்ப்பி",
    
    // Auth
    loginTitle: "மீண்டும் வரவேற்கிறோம்",
    registerTitle: "கணக்கை உருவாக்கு",
    email: "மின்னஞ்சல்",
    password: "கடவுச்சொல்",
    name: "பெயர்",
    phone: "தொலைபேசி",
    confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    noAccount: "கணக்கு இல்லையா?",
    haveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
    registerNow: "இப்போது பதிவு செய்யுங்கள்",
    loginNow: "இப்போது உள்நுழையவும்",
    
    // Add Shop
    addShopTitle: "உங்கள் கடையைச் சேர்க்கவும்",
    shopName: "கடையின் பெயர்",
    shopNameTa: "கடையின் பெயர் (தமிழ்)",
    category: "வகை",
    description: "விளக்கம்",
    descriptionTa: "விளக்கம் (தமிழ்)",
    address: "முகவரி",
    addressTa: "முகவரி (தமிழ்)",
    website: "வலைத்தளம்",
    latitude: "அட்சரேகை",
    longitude: "தீர்க்கரேகை",
    uploadImages: "படங்களை பதிவேற்றவும்",
    workingHours: "வேலை நேரம்",
    submitForApproval: "ஒப்புதலுக்கு சமர்ப்பிக்கவும்",
    
    // Dashboard
    myShops: "என் கடைகள்",
    pending: "ஒப்புதல் நிலுவையில்",
    approved: "அங்கீகரிக்கப்பட்டது",
    rejected: "நிராகரிக்கப்பட்டது",
    edit: "திருத்து",
    delete: "நீக்கு",
    
    // Admin
    adminPanel: "நிர்வாக குழு",
    pendingApprovals: "நிலுவையில் உள்ள ஒப்புதல்கள்",
    allBusinesses: "அனைத்து வணிகங்கள்",
    allUsers: "அனைத்து பயனர்கள்",
    manageCategories: "வகைகளை நிர்வகிக்கவும்",
    approve: "அங்கீகரி",
    reject: "நிராகரி",
    
    // Footer
    footerTagline: "கரூரில் உள்ளூர் வணிகங்களை வாடிக்கையாளர்களுடன் இணைக்கிறது",
    quickLinks: "விரைவு இணைப்புகள்",
    home: "முகப்பு",
    about: "எங்களைப் பற்றி",
    contact: "தொடர்பு",
    privacy: "தனியுரிமைக் கொள்கை",
    copyright: "© 2024 யுனைடெட்ஹேண்ட்ஸ் கரூர். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    
    // Misc
    loading: "ஏற்றுகிறது...",
    error: "ஏதோ தவறு நடந்தது",
    noResults: "முடிவுகள் இல்லை",
    selectCategory: "ஒரு வகையைத் தேர்ந்தெடுக்கவும்",
    allCategories: "அனைத்து வகைகள்"
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ta' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
